



































































// @ts-nocheck
import Vue from 'vue';
import { PayDialogStore, DetailStore } from '@/store/index';
import { FitHalfScreenDialog, FitButton } from '@tencent/wphk-ui';
import { parseAmount } from '@/business/helper';
import charity from '@/business/charity';
import { biHottag } from '@tencent/ppd-base-libs';
import { DonateBtnType } from '@/types';

export default Vue.extend({
  name: 'PayDialog',
  data() {
    return {
      DetailStore,
      PayDialogStore,
      moneyFocus: false,
      showDialog: false,
      isTextDonateBtnType: false,
      selectedOptionDesc: DetailStore.amountOptions[0].desc,
    };
  },
  activated() {
    PayDialogStore.selectedAmount = DetailStore.amountOptions[0].amount;
    this.selectedOptionDesc = DetailStore.amountOptions[0].desc;
    this.isTextDonateBtnType = DetailStore.donateBtnType === DonateBtnType.Text;
    this.hightlightBtn();
  },
  deactivated() {
    this.handleDialogClose();
  },
  methods: {
    handleDialogClose() {
      PayDialogStore.show = false;
    },
    handleSwicthPresetLevel(value: number) {
      PayDialogStore.isUsePreset = true;
      PayDialogStore.selectedLevel = value + 1;
      PayDialogStore.selectedAmount = DetailStore.amountOptions[value].amount;
      this.selectedOptionDesc = DetailStore.amountOptions[value].desc;
      PayDialogStore.inputAmount = '';
      this.hightlightBtn();
    },
    handleSwitchNeedReceipt() {
      PayDialogStore.need_receipt = PayDialogStore.need_receipt === '0' ? '1' : '0';
      biHottag('wallet.charity.detail.reciept_click');
    },
    handleClickConfirm() {
      if (!PayDialogStore.btnActive) {
        return;
      }
      // 无需收据时，直接跳转捐款
      if (PayDialogStore.need_receipt === '0') {
        charity.orderReq(true);
        return;
      }
      this.$router.push({ path: 'person' });
      biHottag('wallet.charity.detail.order_click', {
        fcharity_project: sessionStorage.getItem('pid'),
        fcharity_organization: sessionStorage.getItem('oid'),
      });
    },
    handleInputFocus() {
      this.moneyFocus = true;
      PayDialogStore.isUsePreset = false;
      this.hightlightBtn();
    },
    handleInputBlur() {
      this.moneyFocus = false;
    },
    handleInputChange(e) {
      const oldValue = PayDialogStore.inputAmount || '';
      let { value } = e.target;
      // 只允许输入数字和小数点
      value = value.replace(/[^0-9.]/g, '');
      // 格式化金额输入
      value = parseAmount(value, oldValue);
      // 直接更新store和input的值
      PayDialogStore.inputAmount = value;
      // eslint-disable-next-line no-param-reassign
      e.target.value = value;
      charity.checkAmount();
      this.hightlightBtn();
    },
    hightlightBtn() {
      if (!PayDialogStore.isUsePreset) {
        // 最低金额限制检查
        const inMoney = parseFloat(PayDialogStore.inputAmount || '0');
        if (0 === inMoney || inMoney < (this.DetailStore.lowAmount || 0.1)) {
          PayDialogStore.btnActive = false;
          return;
        }
      }
      PayDialogStore.btnActive = true;
    },
    showTencentTips() {
      DetailStore.tencentCharityTipsShow = true;
    },
  },
  components: {
    FitHalfScreenDialog,
    FitButton,
  },
});
